export default __webpack_public_path__ + "img/devices.b2b35f.svg";